/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 請求金額
 * @export
 * @interface PaymentsSummaryRow
 */
export interface PaymentsSummaryRow {
    /**
     * 月
     * @type {number}
     * @memberof PaymentsSummaryRow
     */
    month: number;
    /**
     * 営業所ID
     * @type {number}
     * @memberof PaymentsSummaryRow
     */
    officeId: number;
    /**
     * 営業所名称
     * @type {string}
     * @memberof PaymentsSummaryRow
     */
    officeName: string;
    /**
     * 金額
     * @type {number}
     * @memberof PaymentsSummaryRow
     */
    price: number;
    /**
     * 対象乗務員数
     * @type {number}
     * @memberof PaymentsSummaryRow
     */
    nDrivers: number;
    /**
     * 課金対象Trip数
     * @type {number}
     * @memberof PaymentsSummaryRow
     */
    nChargeableTrips: number;
    /**
     * 確定
     * @type {boolean}
     * @memberof PaymentsSummaryRow
     */
    fixed: boolean;
}

export function PaymentsSummaryRowFromJSON(json: any): PaymentsSummaryRow {
    return PaymentsSummaryRowFromJSONTyped(json, false);
}

export function PaymentsSummaryRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentsSummaryRow {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'month': json['month'],
        'officeId': json['office_id'],
        'officeName': json['office_name'],
        'price': json['price'],
        'nDrivers': json['n_drivers'],
        'nChargeableTrips': json['n_chargeable_trips'],
        'fixed': json['fixed'],
    };
}

export function PaymentsSummaryRowToJSON(value?: PaymentsSummaryRow | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'month': value.month,
        'office_id': value.officeId,
        'office_name': value.officeName,
        'price': value.price,
        'n_drivers': value.nDrivers,
        'n_chargeable_trips': value.nChargeableTrips,
        'fixed': value.fixed,
    };
}


